export default __webpack_public_path__ + "static/media/alerts_icon.b5f9a163.png";